import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import ApplicationSentView from './ApplicationSentView';
import SelfServeFormView from './SelfServeFormView/SelfServeFormView';
import { useIsMobile } from '../../common/hooks/useIsMobile';

const Root = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  background-position: bottom left;
  background-repeat: no-repeat;
  align-items: center;
  background-color: ${cssThemedValue('surfaceMain')};
  padding-block-end: ${({ isMobile }) =>
    isMobile ? 'padding-block-end: min(40vw, 312px)' : 'padding-block-end: max(32px, 7vw)'};
  background-size: ${({ isMobile }) => (isMobile ? 'auto min(40vw, 312px)' : '380px auto')};
`;

const SelfServeSignUp = () => {
  const { url } = useRouteMatch();
  const isMobile = useIsMobile();
  const history = useHistory();

  return (
    <Root isMobile={isMobile}>
      <Switch>
        <Route exact path={url}>
          <SelfServeFormView onSuccess={() => history.push(`${url}/application-sent`)} />
        </Route>
        <Route exact path={`${url}/application-sent`} component={ApplicationSentView} />
      </Switch>
    </Root>
  );
};

export default SelfServeSignUp;
